"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
const SalesOrderContext_1 = require("../../../../../features/base/ordering/contexts/SalesOrderContext");
const FlatCard_1 = require("../BasicComponents/FlatCard");
const RetailLocationsContext_1 = require("../../../../../features/base/ordering/contexts/RetailLocationsContext");
const styles = require("./ReviewCartItems.styles.scss");
const StripePaymentOptions_1 = require("../StripePaymentOptions/StripePaymentOptions");
exports.default = ({}) => {
    var _a, _b, _c;
    const _d = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext), { salesOrderItems, totalPrice, promotions } = _d, all = __rest(_d, ["salesOrderItems", "totalPrice", "promotions"]);
    const { retailLocation } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    console.log(salesOrderItems, totalPrice, promotions);
    let allItems = salesOrderItems.map(x => (React.createElement(SingleCartItem, { title: x.title, price: x.cost, description: x.description, quantity: x.quantity })));
    return (React.createElement(FlatCard_1.default, null,
        React.createElement(OrderTitle, { storeAddress: (_b = (_a = retailLocation === null || retailLocation === void 0 ? void 0 : retailLocation.address) === null || _a === void 0 ? void 0 : _a.fullAddress) !== null && _b !== void 0 ? _b : "", storeName: (_c = retailLocation === null || retailLocation === void 0 ? void 0 : retailLocation.title) !== null && _c !== void 0 ? _c : "", orderType: "PICKUP" }),
        React.createElement("div", { style: { display: "flex", flexDirection: "column" } }, allItems),
        React.createElement(OrderTotal, { subTotal: totalPrice, total: totalPrice })));
};
const OrderTitle = ({ storeName, storeAddress, orderType }) => {
    var _a;
    let storeTitle = (_a = storeName === null || storeName === void 0 ? void 0 : storeName.toUpperCase()) !== null && _a !== void 0 ? _a : "";
    return (React.createElement("div", { className: styles.titleContainer },
        React.createElement("div", { className: styles.titleRow }, orderType),
        React.createElement("div", { className: styles.titleRow },
            React.createElement("span", { className: styles.storePrefix }, "FROM "),
            storeTitle),
        React.createElement("div", { style: { fontSize: 12, color: "black" }, className: styles.titleRow }, storeAddress)));
};
const OrderTotal = ({ total, subTotal }) => {
    let totalLabel = (0, StripePaymentOptions_1.formatTotalDollars)(total);
    return (React.createElement("div", { className: styles.cartTotalContainer },
        React.createElement("div", { className: styles.cartSubTotalLabel },
            "TOTAL: ",
            totalLabel)));
};
const SingleCartItem = ({ title, price, quantity, description }) => {
    let priceLabel = (0, StripePaymentOptions_1.formatTotalDollars)(price);
    return (React.createElement("div", { style: {
            display: "flex",
            flex: 1,
            margin: 5,
            padding: 15,
            borderRadius: 15,
            background: "#D5ECDD"
        } },
        React.createElement("div", { className: styles.cartItemLabel, style: { flex: 4 } },
            React.createElement("div", { style: {
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column"
                } },
                React.createElement("div", null,
                    quantity,
                    " x ",
                    title),
                React.createElement("div", { className: styles.cartItemDescription }, description))),
        React.createElement("div", { className: styles.cartItemPrice, style: { flex: 1, display: "flex", justifyContent: "flex-end" } },
            React.createElement("div", { style: {
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column"
                } }, priceLabel))));
};
//# sourceMappingURL=ReviewCartItems.js.map